module.exports = __webpack_public_path__ + "static/media/REW_Results2.4c1666ff.jpg";